import { SET_SCHEMES_OPTIONS_IN_STORE } from '../types';

export const setSchemeOptionsInStore = (data) => {
  return {
    type: SET_SCHEMES_OPTIONS_IN_STORE,
    data,
  };
};

